export * from './lib/get-region-variable';
